import { render } from "./NonHumanIdentityForm.vue?vue&type=template&id=4a35b5df"
import script from "./NonHumanIdentityForm.vue?vue&type=script&lang=js"
export * from "./NonHumanIdentityForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__